<template>
  <v-dialog v-model="displayForm" persistent max-width="980px">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title>
          <span class="headline" v-if="item">Update Currency</span>
          <span class="headline" v-else>Add Currency</span>
        </v-card-title>
        <div class="text-xs-center">
          <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
        </div>
        <v-card-text v-if="!loading">
          <v-alert
            :value="message"
            type="error"
            dismissible
            transition="scale-transition"
          >{{ message }}</v-alert>

          <v-row>
            <v-col>
              <v-text-field v-model="model.name" label="Name" :rules="mandatoryRules" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field v-model="model.currency" label="Currency" :rules="mandatoryRules" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field v-model="model.tva" label="TVA" :rules="mandatoryRules" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <CurrenciesSelect v-model="model.bexio_id" label="Bexio Currency" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel()" :disabled="loading">Cancel</v-btn>
          <v-btn
            v-if="item"
            color="blue darken-1"
            text
            @click="update()"
            :disabled="loading"
          >Update</v-btn>
          <v-btn v-else color="blue darken-1" text @click="add()" :disabled="loading">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import CurrenciesSelect from '../../../components/bexio/form/CurrenciesSelect.vue';

function getDefaultData() {
  return {
    model: {
      id: null,
      name: null,
      currency: null,
      locationId: null
    },
    mandatoryRules: [v => !!v || "This fiels is mandatory"],
    message: null,
    valid: null
  };
}
export default {
    components: { CurrenciesSelect},
    props: ["item", "open", "id"],
    data: getDefaultData,
    computed: {
        displayForm: function () {
            return this.open;
        },
        loading: function () {
            return this.$store.getters["currencies/loading"];
        }
    },
    watch: {
        item: function (newVal) {
            // watch it
            Object.assign(this.model, newVal);
        }
    },
    methods: {
        add() {
            if (this.$refs.form.validate()) {
                this.model.locationId = this.id;
                this.$store
                    .dispatch("currencies/add", {
                    model: this.model
                })
                    .then(({currency}) => {
                    if (currency.id) {
                        this.$emit("add");
                        this.resetForm();
                    }
                    else {
                        this.message = currency.message;
                    }
                });
            }
        },
        update() {
            if (this.$refs.form.validate()) {
                this.$store
                    .dispatch("currencies/update", {
                    model: this.model
                })
                    .then(result => {
                    if (result.id) {
                        this.$emit("update");
                        this.resetForm();
                    }
                    else {
                        this.message = result.message;
                    }
                });
            }
        },
        cancel() {
            this.$emit("cancel");
            this.resetForm();
        },
        resetForm() {
            Object.assign(this.$data, getDefaultData());
            this.$refs.form.reset();
        }
    }
};
</script>

<style></style>
